<template>
    <div id="userMain"> 
        <router-view></router-view>
        
        <ul id="slide-out" class="sidenav sidenav-fixed" style="margin-top: 65px; background-color: #FAFAFA">
            <li style="margin-left: 40px">
                <div class="user-view" style="padding: 20px;">
                    <!-- <h5> {{$t('user.welcomeMsg')}} </h5> -->
                    <p v-if="name.length != 0" style="font-size: 16px">{{ vorname }} {{ name }}</p>
                    <!-- <h6>{{ email }}</h6> -->
                </div>
            </li>

            <!-- <li><div class="divider"></div></li> -->
            <!-- <li><a class="subheader">Modules</a></li> -->

            <li v-if="preisfinderToggle" class="" style="margin-left: 30px;">
                <router-link to="/user/preisfinder" class="sidenav-close" style="font-size: 16px"> {{$t('user.priceFinder')}} </router-link>
            </li>
     
            <li v-if="restwertkalkulator" style="margin-left: 30px">
                <router-link to="/user/restwertkalkulator" class="sidenav-close" style="font-size: 16px"> {{$t('user.residualValueCalculation')}} </router-link>
            </li>

            <!-- <li v-if="preisbewertung" style="margin-left: 30px">
                <router-link to="/user/preisbewertung" class="sidenav-close" style="font-size: 16px"> {{$t('user.priceValuation')}} </router-link>
            </li> -->
            <li v-if="preisbewertung" style="margin-left: 30px">
                <router-link to="/user/preisbewertung" class="sidenav-close" style="font-size: 16px"> {{$t('user.priceValuation')}} </router-link>
            </li>

            <li v-if="dashboard" style="margin-left: 30px">
                <router-link to="/user/dashboard" class="sidenav-close" style="font-size: 16px"> {{$t('user.dashboardAnalytics')}} </router-link>
            </li>

            <!-- <li><div class="divider"></div></li> -->
            <!-- <li><a class="subheader">{{$t('user.personalInformation')}}</a></li> -->

            <!-- <li>
                <router-link to="/user/profile" class="sidenav-close"> {{$t('user.myProfile')}} </router-link>
            </li> -->

            <!-- <li><div class="divider"></div></li> -->
            <!-- <li>
                <a class="grey darken-3 waves-effect waves-light btn" v-on:click="logoutBtnTapped"> {{$t('user.logout')}} </a>
            </li> -->
        </ul>
    </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import firebase from "firebase";
import firebaseInit from "../components/firebaseInit";
export default {
    name: "userMain",
    data() {
        return {
        name: "",
        vorname: "",
        email: "",
        preisfinderToggle: null,
        restwertkalkulator: null,
        preisbewertung: null,
        dashboard: null
        }
    },

    created(){
        this.fetchData()
    },

    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },

    mounted() {
        var sidenavInit = document.querySelectorAll(".sidenav");
        var instances = M.Sidenav.init(sidenavInit, {});
    },

    methods: {
        fetchData(){
        const currentUserUID = firebase.auth().currentUser.uid
        const currentUserDoc = firebaseInit.collection("user").doc(currentUserUID);

        currentUserDoc.get().then((doc) =>  {
                if (doc.exists) {
                    this.vorname = doc.data().vorname
                    this.name = doc.data().name
                    this.preisfinderToggle = doc.data().preisfinder
                    this.restwertkalkulator = doc.data().restwertkalkulator
                    this.preisbewertung = doc.data().preisbewertung
                    this.dashboard = doc.data().dashboard
                } else {
                    console.log("No such document!");
                }        
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
        },

        logoutBtnTapped() {
        firebase
            .auth()
            .signOut()
            .then(
            () => {
                this.$router.replace("/");
                window.location.reload();
            },
            error => {
                console.log(error);
            }
            );
        },
    } 
}
</script>